import { Component, EventEmitter, Event, h, Prop, Listen } from '@stencil/core';
import { SVGIcon } from '../icons/svg-icon';

@Component({
  tag: 'filter-input',
  styleUrl: 'filter-input.css',
  shadow: true,
})
export class FilterInput {
  private textInput?: HTMLInputElement;
  @Event({
    eventName: 'opti-dropdown-query-updated',
  })
  queryUpdated: EventEmitter<{ query: string; parentId: string }>;

  @Prop()
  placeholder: string;

  @Prop()
  parentId: string;

  @Listen('opti-nav-menu-focusin', { target: 'body' })
  navMenuFocusIn() {
    this.textInput.value = '';
    this.queryUpdated.emit({ query: '', parentId: this.parentId });
  }

  constructor() {
    this.queryUpdatedHandler = this.queryUpdatedHandler.bind(this);
  }

  queryUpdatedHandler(event) {
    this.queryUpdated.emit({ query: event.currentTarget.value, parentId: this.parentId });
  }

  render() {
    return (
      <div class="filter">
        <span class="filter-icon">
          <SVGIcon name="magnifying-glass" color="black" width={16} height={16}></SVGIcon>
        </span>
        <input ref={el => (this.textInput = el as HTMLInputElement)} class="filter-input" type="text" placeholder={this.placeholder} onInput={this.queryUpdatedHandler} />
      </div>
    );
  }
}
